import { render, staticRenderFns } from "./DigitPad.vue?vue&type=template&id=06db15a4&scoped=true&"
import script from "./DigitPad.vue?vue&type=script&lang=js&"
export * from "./DigitPad.vue?vue&type=script&lang=js&"
import style0 from "./DigitPad.vue?vue&type=style&index=0&id=06db15a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06db15a4",
  null
  
)

export default component.exports